/** Order request statuses from UID/WMS: REJECTED=7, WAIT_CANCELLED=8 */
export const OUTBOUND_CANCELLED_STATUSES = [7, 8];

export const workItemUnitOptions = [
  { value: 1, label: 'Công lắp' },
  { value: 2, label: 'Công bảo hành' },
  { value: 3, label: 'VNĐ' },
];

export const fulfillmentMethodOptions = [
  { label: 'Shopee', value: 'shopee' },
  { label: 'ViettelPost', value: 'viettelpost' },
  { label: 'Nhất Tín', value: 'nhattin' },
  { label: 'GHN', value: 'ghn' },
  { label: 'GHTK', value: 'ghtk' },
  { label: 'AhaMove', value: 'ahamove' },
  { label: 'Grab', value: 'grab' },
  { label: 'J&T', value: 'jnt' },
  { label: 'Other', value: 'other' },
];
